import { render, staticRenderFns } from "./EditPalette.vue?vue&type=template&id=e1ba1c12&scoped=true&"
import script from "./EditPalette.vue?vue&type=script&lang=js&"
export * from "./EditPalette.vue?vue&type=script&lang=js&"
import style0 from "./EditPalette.vue?vue&type=style&index=0&id=e1ba1c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ba1c12",
  null
  
)

export default component.exports